import { CustomValueContainer } from '@/design-system/select/selectV1';
import React from 'react';

export const useFilterCustomFields = ({
  customFilterConfig,
  expanded,
  name,
  selectedFilter,
  toggleExpandCollapse,
}) => {
  const { kind } = customFilterConfig || {};

  // Common base configuration
  const commonConfig = {
    name,
    label: '',
    isRequired: false,
    isNewFilter: true,
    expanded,
    components: {
      ValueContainer: (customProps) => (
        <CustomValueContainer
          {...customProps}
          expanded={expanded}
          selectedFilter={selectedFilter}
          toggleExpandCollapse={toggleExpandCollapse}
        />
      ),
    },
  };

  switch (kind) {
    case 'number':
      return {
        ...commonConfig,
        type: 'plainInput',
        inputType: 'number',
        isMulti: false,
        isBoolean: false,
        isCompare: true,
        styles: {
          fontSize: '12px',
          height: '36px',
          border: '1px solid #D9D9D9',
          borderRadius: '8px',
        },
      };

    case 'rel_tag':
      return {
        ...commonConfig,
        type: 'select',
        options: customFilterConfig?.values?.map((itr) => ({
          label: itr?.value,
          value: itr?.id,
        })),
        validationType: 'array',
        isMulti: customFilterConfig?.multi,
        isCompare: false,
        isBoolean: false,
        isAppendToBody: true,
      };

    case 'enum_boolean':
      return {
        ...commonConfig,
        type: 'select',
        options: [
          { value: 'true', label: 'Yes' },
          { value: 'false', label: 'No' },
        ],
        validationType: 'boolean',
        isMulti: false,
        isCompare: false,
        isBoolean: true,
        isAppendToBody: true,
      };

    case 'date':
      return {
        ...commonConfig,
        type: 'filterDatePicker',
        validationType: 'date',
        isCompare: true,
        isMulti: false,
        isBoolean: false,
        isCustomize: true,
        fieldKey: 'date',
      };

    default:
      return null; // Return null or a default value if no matching kind is found
  }
};
